import { Outlet } from 'react-router-dom';
import ProtectedRoute, {
  ProtectedPage,
} from '../../ui-framework/components/Routing/ProtectedRoute';

function splitRoutes(routes) {
  const publicRoutes = [];
  const protectedRoutes = [];

  routes.forEach(route => {
    if (route.element?.type === ProtectedRoute) {
      protectedRoutes.push({
        ...route,
        element: <ProtectedPage {...route.element.props} />,
      });
    } else if (route.children) {
      const children = splitRoutes(route.children);
      if (children.publicRoutes.length) {
        publicRoutes.push({ ...route, children: children.publicRoutes });
      }
      if (children.protectedRoutes.length) {
        protectedRoutes.push({ ...route, children: children.protectedRoutes });
      }
    } else {
      publicRoutes.push(route);
    }
  });

  return { publicRoutes, protectedRoutes };
}

export default function groupProtectedRoutes(
  routes,
  { errorElement, ...errorProps },
) {
  const { publicRoutes, protectedRoutes } = splitRoutes(routes);
  return [
    ...publicRoutes,
    {
      // Keep authenticated providers mounted when the matched page changes depth.
      element: <ProtectedRoute {...errorProps} Component={Outlet} />,
      errorElement,
      children: protectedRoutes,
    },
  ];
}
